import init from './thing'

const mediaObject =
{
    ...init
};

export default mediaObject ;
